import { jsx as _jsx } from "react/jsx-runtime";
import { DescriptionList } from "../../../../DescriptionList";
import { DescriptionListItem } from "../../../../DescriptionListItem";
export var FormSummaryItem = function (_a) {
    var title = _a.title, value = _a.value, valueSelector = _a.valueSelector, selectedValue = _a.selectedValue, error = _a.error;
    return (_jsx(DescriptionList, { termWidth: 400, children: _jsx(DescriptionListItem, { term: title, description: valueSelector ? selectedValue : value, error: error }) }));
};
